module.exports = __webpack_public_path__ + "img/EMobiledataOutlined.6b5e3be8.svg";